import "./Images.css";

import { useRef, useState, useEffect } from "react";
import { getUploadFileUrl, getUploadThumbUrl } from "../../consts";

import IconEye from "../../assets/images/eye.svg";
import IconDel from "../../assets/images/x.svg";

import { createObjectURL, revokeObjectURL } from "../../axios_with_token";

import { UploadFile, AddUrl, randomUUID } from "../../axios_with_token";

export function ImgCard({imgDef, idx, btns, handleDelImage, urlCache}){
    const _btns = btns?btns.split(","):[];
    return <div className="card m-1" 
        title={imgDef.name || imgDef.url}
        style={{
            width: "100px",
            height: "100px" 
        }}
    >
        <div className="card-body conatiner p-0" style={{
            // "backgroundImage":`url("${(urlCache[imgDef.url]||{}).url || getUploadThumbUrl(imgDef.url)}")`,
            "backgroundImage":`url("${ imgDef.url&&(imgDef.url.startsWith('data:image/')?imgDef.url:getUploadThumbUrl(imgDef.url))}")`,
            "backgroundRepeat": "no-repeat",
            "backgroundSize": "contain",
            "backgroundPosition": "center",
            "height":"5em"
        }}>
            {(!_btns||(_btns.indexOf("delete")>-1))&&<button type="button" className="btn float-end m-0 p-0" aria-label="Close"
                idx={idx}
                onClick={handleDelImage}
            ><img src={IconDel} className="pe-none m-0" style={{"width":"1em"}}/></button>}
            {(!_btns||(_btns.indexOf("show")>-1))&&<a className="btn float-end m-0 p-0"
                href={getUploadFileUrl(imgDef.url)}
                target="_blank"
            ><img src={IconEye} className="pe-none m-0" style={{"width":"1em"}}/></a>}
            {/* <h5 className="card-title">{imgDef}</h5> */}
            {/* <p className="card-text">img-{idx+1}</p> */}
            {/* <a href="#" className="btn btn-primary">Go somewhere</a> */}
        </div>
    </div>
}

export default function Images({fldName, form, fldDef, opts}){
    opts = opts || {};
    const {onChange, ...rest} = form.register(fldName, {required: 1})

    const refData = useRef({
        urlCache: {}
    });

    // [] set init value
    const valToImgs = val=>{
        let imgs = [];
        try{
            imgs=JSON.parse(val||"[]")
        }catch(err){
            console.log(err);   
            imgs = [];
        }
        return imgs;        
    };
    const [imgs, setImgs] = useState(valToImgs(form.getValues()[fldName]));
    const setVal = newValFiles=>{
        const newVal = JSON.stringify(newValFiles);
        form.setValue(fldName, newVal);
        setImgs(newValFiles);        
    }

    
    const uuid=randomUUID();
    const setFormValAndUpdateUI = newValImgs=>{
        const newVal = JSON.stringify(newValImgs);
        form.setValue(fldName, newVal);
        setImgs(newValImgs); 
    }
    const refFile = useRef();
    const refQlty = useRef();
    const refSize = useRef();
    const refCvs = useRef();

    const addImg = file=>{
        return new Promise((res,rej)=>{
            let src = createObjectURL(file);

            let img = new Image(); 
            img.onerror=function(err){
                rej(err);
            };
            img.onload = evt=>{
                // resize
                let width, height;
                {
                    let max_size = parseInt(refSize.current.value);//1024,// TODO : pull max size from a site config
                    
                    width = img.width;
                    height = img.height;

                    let ratio;
                    if(max_size && !isNaN(max_size) && max_size>=100 && width>max_size && height>max_size){
                        ratio = width/height;
                        height =  (width > height)?max_size:max_size/ratio;
                        width = height*ratio;
                    }
                }
                let cvs = refCvs.current;
                let qlty = refQlty.current.value;

                cvs.width = width;
                cvs.height = height;
                cvs.getContext('2d').drawImage(img, 0, 0, width, height);

                res({
                    url: cvs.toDataURL('image/jpeg', parseFloat(qlty)),
                    name: file.name,
                    caption: file.name
                });
            }

            img.src = src;
        });
    };

    //[] file change handler
    const handleFileChange = evt=>{
        Promise.all(
            Array.prototype.map.call(evt.target.files, addImg)
        ).then(newImgs=>{
            evt.target.value = '';
            const newValImgs = [...imgs, ...newImgs];
            setFormValAndUpdateUI(newValImgs);
        });
        // .then(newImgs=>{
        //     evt.target.value = '';
        //     for(let i in newImgs){
        //         let uuid = `formCache-${randomUUID()}`;
        //         refData.current.urlCache[uuid] = {
        //             url: newImgs[i].url,
        //             fileName: newImgs[i].name
        //         };
        //         newImgs[i].url = uuid;
        //     }
        //     const newValImgs = [...imgs, ...newImgs];
        //     setFormValAndUpdateUI(newValImgs);
        // });
    }
    // const handleFileChange = evt=>{
    //     Promise.all(
    //         Array.prototype.map.call(evt.target.files, addImg)
    //     ).then(newImgs=>{
    //         evt.target.value = '';
    //          //[] replace dataUrl with uuid
    //         for(let i in newImgs){
    //             let uuid = `formCache-${randomUUID()}`;
    //             refData.current.urlCache[uuid] = {
    //                 url: newImgs[i].url,
    //                 fileName: newImgs[i].name
    //             };
    //             newImgs[i].url = uuid;
    //         }
    //         const newValImgs = [...imgs, ...newImgs];
    //         setFormValAndUpdateUI(newValImgs);
    //     });
    // }

    const handleAddImage = evt=>{
        if(opts.allowMuitiple){
            refFile.current.setAttribute('multiple', 'multiple');
        }else{
            refFile.current.removeAttribute('multiple');
        }

        setTimeout(function(){
            refFile.current.click();
        },200);
    }

    const handleDelImage = evt=>{
        // imgs.splice(1,1);
        const idx = parseInt(evt.target.getAttribute('idx'));
        // delete formCache[imgs[idx].url];
        delete refData.current.urlCache[imgs[idx].url];
        imgs.splice(idx, 1);
        setFormValAndUpdateUI([...imgs]);
    }

    return <div className="accordion input-images" id={"accordion-"+uuid}>
        <input className="form-control" type="hidden" {...rest} />
        
        <canvas ref={refCvs} style={{"display":"none"}}></canvas>
        {/* <input 
            type="file" 
            accept=".jpg, .png, .jpeg, .gif, .bmp, .tif, .tiff|image/*" 
            ref={refFile}
            onChange={handleFileChange}
            style={{"display": "none"}}
        /> */}

        <div className="accordion-item">
            <div className="accordion-header" id={"heading-settings-"+uuid}>
                <div className="m-0 accordion-button my-0 py-1">
                    {/* <button className="btn hover-overlay py-1 images-btn-new" type="button"
                        title="click to select file or drag image on this button."
                        onClick={handleAddImage}
                    >+</button> */}
                    <UploadFile
                        btnClass="btn hover-overlay py-1 images-btn-new"
                        onUploaded={newFiles=>{
                            const newValFiles = [...imgs, ...newFiles.map(newFile=>({
                                url: newFile.fileUrl,
                                name:  newFile.fileName
                            }))];
                            setVal(newValFiles);
                        }}
                        allowMultiple={true}
                    ></UploadFile>
                    <AddUrl
                        btnClass="btn hover-overlay py-1 images-btn-new"
                        onAdded={newUrls=>{
                            const newValFiles = [...imgs, ...newUrls.map(newUrl=>({
                                url: newUrl.url,
                                name:  newUrl.name
                            }))];
                            setVal(newValFiles);
                        }}
                        allowMultiple={true}
                    ></AddUrl>

                    <button className="btn py-1 images-settings-toggle collapsed" type="button"
                        data-bs-toggle="collapse"
                        data-bs-target={"#collapse-settings-"+uuid}
                    >
                        settings
                    </button>

                    <button className="btn py-1 images-settings-toggle" type="button"
                        data-bs-toggle="collapse"
                        data-bs-target={"#collapse-images-"+uuid}
                    >
                        images <span className="pull-right">( {imgs.length} )</span>
                    </button>
                </div>
            </div>

            <div id={"collapse-settings-"+uuid}
                className="accordion-collapse collapse show"
                aria-labelledby={"heading-settings-"+uuid}
                data-bs-parent={"#accordion-"+uuid}
            >
                <div className="accordion-body border-bottom">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="input-group d-flex">
                                <span className="input-group-text">max size</span>
                                <select className="form-control col" name="" id={"maxsize-"+uuid}
                                    defaultValue={800}
                                    ref={refSize}
                                >
                                    <option value="200">200</option>
                                    <option value="400">400</option>
                                    <option value="800">800</option>
                                    <option value="1024">1024</option>
                                    <option value="1536">1536</option>
                                    <option value="2048">2048</option>
                                    <option value="0">no resize</option>
                                </select>
                            </div>
                            
                        </div>
                        <div className="col-md-6">
                            <div className="input-group d-flex">
                                <span className="input-group-text">quality</span>
                                <select className="form-control" name="" id={"quality-"+uuid}
                                    defaultValue={0.8}
                                    ref={refQlty}
                                >
                                    <option value="0.1">0.1</option>
                                    <option value="0.2">0.2</option>
                                    <option value="0.3">0.3</option>
                                    <option value="0.4">0.4</option>
                                    <option value="0.5">0.5</option>
                                    <option value="0.6">0.6</option>
                                    <option value="0.7">0.7</option>
                                    <option value="0.8">0.8</option>
                                    <option value="0.9">0.9</option>
                                    <option value="1">1</option>
                                </select>
                            </div>                            
                        </div>
                    </div>
                </div>
            </div>

            <div id={"collapse-images-"+uuid}
                className="accordion-collapse collapse show"
                aria-labelledby="headingOne"
                data-bs-parent={"#accordion-"+uuid}
            >
                <div className="accordion-body border-bottom image-list">
                    <div className="container" style={{marginLeft: "0"}}>
                        <div className="row">
                            {/* <h1>{imgs.length}</h1> */}
                            {imgs.map((imgDef, idx)=>{
                                return <ImgCard key={idx} 
                                    idx={idx}
                                    imgDef={imgDef}
                                    handleDelImage={handleDelImage}
                                    btns={'delete,show'}
                                    urlCache={refData.current.urlCache}
                                />;
                            })}
                        </div>
                    </div>
                </div>
            </div>            
        </div>
    </div>
}

